"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthSyncState = exports.authSync = void 0;
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const auth_1 = require("firebase/auth");
const firestore_1 = require("@firebase/firestore");
const function_client_1 = require("common/function-client");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const { EventEmitter } = eventemitter3_1.default;
const react_1 = require("react");
const auth_firebase_1 = require("common/auth-firebase");
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
const getVerifiedEmail = (token) => {
    var _a, _b;
    const email = token === null || token === void 0 ? void 0 : token["email"];
    if ((token === null || token === void 0 ? void 0 : token["email_verified"]) === true) {
        return email;
    }
    else if (((_a = token === null || token === void 0 ? void 0 : token.firebase) === null || _a === void 0 ? void 0 : _a.sign_in_provider) &&
        ["google.com", "microsoft.com"].includes((_b = token === null || token === void 0 ? void 0 : token.firebase) === null || _b === void 0 ? void 0 : _b.sign_in_provider)) {
        return email;
    }
};
class AuthSync {
    constructor() {
        this.userClaim = undefined;
        this.authEmailObserverUnsubscriber = undefined;
        this.externalAuthorizationObserverUnsubscriber = undefined;
        this.authSyncUpdating = false;
        this.emitter = new EventEmitter();
        auth.onIdTokenChanged((user) => __awaiter(this, void 0, void 0, function* () {
            if (user) {
                this.userClaim = (yield user.getIdTokenResult()).claims;
                console.log("onIdTokenChanged", this.userClaim);
                this.onUpdateUser();
            }
            else {
                this.changeAuthSyncState(false);
            }
        }));
    }
    onAuthSyncUpdating(callback) {
        this.emitter.on("authSyncUpdating", callback);
        return () => {
            this.emitter.off("authSyncUpdating", callback);
        };
    }
    changeAuthSyncState(authSyncUpdating) {
        // console.error("#changeAuthSyncState", authSyncUpdating);
        if (this.authSyncUpdating !== authSyncUpdating) {
            this.emitter.emit("authSyncUpdating", authSyncUpdating);
            this.authSyncUpdating = authSyncUpdating;
        }
        else {
            this.authSyncUpdating = authSyncUpdating;
        }
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                yield (0, function_client_1.assignRoleToSelf)();
            }
            catch (e) {
                //
            }
            yield wait(300);
            yield ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken(true));
        });
    }
    onUpdateUser() {
        var _a;
        if (this.authEmailObserverUnsubscriber !== undefined) {
            this.authEmailObserverUnsubscriber();
        }
        if (this.externalAuthorizationObserverUnsubscriber !== undefined) {
            this.externalAuthorizationObserverUnsubscriber();
        }
        const verifiedEmail = getVerifiedEmail(this.userClaim);
        if (!verifiedEmail) {
            console.log("email not verified");
            this.changeAuthSyncState(false);
            return;
        }
        let authEmailSnapshots = null;
        let externalAuthorizationSnapshots = null;
        const checkChange = () => __awaiter(this, void 0, void 0, function* () {
            if (authEmailSnapshots && externalAuthorizationSnapshots) {
                const remoteClaims = (0, auth_firebase_1.calculateClaims)(authEmailSnapshots, externalAuthorizationSnapshots);
                if ((0, auth_firebase_1.hasChange)(remoteClaims, this.userClaim)) {
                    yield this.refreshToken();
                }
                else {
                    console.log("no change");
                    this.changeAuthSyncState(false);
                }
            }
        });
        if ((_a = this.userClaim) === null || _a === void 0 ? void 0 : _a.sub) {
            const ea = (0, firestore_1.doc)(firestore, "externalAuthorization", this.userClaim.sub);
            this.externalAuthorizationObserverUnsubscriber = (0, firestore_1.onSnapshot)(ea, (snapshot) => __awaiter(this, void 0, void 0, function* () {
                externalAuthorizationSnapshots = [snapshot];
                yield checkChange();
            }));
        }
        this.authEmailObserverUnsubscriber = (0, firestore_1.onSnapshot)((0, firestore_1.query)((0, firestore_1.collectionGroup)(firestore, "authEmail"), (0, firestore_1.where)("email", "==", verifiedEmail)), (snapshot) => __awaiter(this, void 0, void 0, function* () {
            authEmailSnapshots = snapshot.docs;
            yield checkChange();
        }));
        this.changeAuthSyncState(true);
    }
}
exports.authSync = new AuthSync();
const useAuthSyncState = () => {
    const [authSyncUpdating, setAuthSyncUpdating] = (0, react_1.useState)(exports.authSync.authSyncUpdating);
    console.log("#useAuthSyncState", authSyncUpdating);
    (0, react_1.useEffect)(() => {
        const unsubscriber = exports.authSync.onAuthSyncUpdating((authSyncUpdating) => {
            console.log("#useAuthSyncState(effect)", authSyncUpdating);
            setAuthSyncUpdating(authSyncUpdating);
        });
        return () => {
            unsubscriber();
        };
    }, []);
    return authSyncUpdating;
};
exports.useAuthSyncState = useAuthSyncState;
